import React from 'react';

import ThemeSettings from '../../../theme';
import { Text }      from './Text';
import classNames from 'classnames';
import styles        from './Text.css';

type HeadingProps = {
    color?: string;
    size?: string;
    className?: string;
    children?: any;
};

export const H1 = ({children, className, ...props}: HeadingProps) => {
    const newProps = {...props};
    newProps.size = props.size || ThemeSettings.text.h1;

    return (
        <Text {...newProps} as = "h1" className = {classNames(styles.Header, className)}>
            {children}
        </Text>
    );
};

export const H2 = ({className, children, ...props}: HeadingProps) => {
    const newProps = {...props};
    newProps.size = props.size || ThemeSettings.text.h2;

    return (
        <Text {...newProps} as = "h2" className = {classNames(styles.Header, className)}>
            {children}
        </Text>
    );
};

export const H3 = ({className, children, ...props}: HeadingProps) => {
    const newProps = {...props};
    newProps.size = props.size || ThemeSettings.text.h3;

    return (
        <Text {...newProps} as = "h3" className = {classNames(styles.Header, className)}>
            {children}
        </Text>
    );
};
